module.exports = __webpack_public_path__ + "static/media/sc-4.300b25a7.png";